<template>
  <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="innerVisible" :title="$t('CargoMsg.Cargo_FinancialAudit')" width="500px" @close="cancel">
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form label-width="100px" label-position="left" @submit.native.prevent>
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_PleaseConfirmReviewDate')">
            <el-date-picker
              v-model="accountDate"
              type="date"
              style="width:251px;"
              clearable
              :disabled="!editApprovalDate"
              :picker-options="pickerOptions"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ItemNo')">
            <el-input v-model="poNo" :disabled="!isEditable" style="width:251px;" />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="confirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button size="mini" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { Assert } from '@/utils/validate'
import moment from 'moment'

export default {
  name: 'CACheckDialog',
  components: { },
  props: {
    showPageDate: { type: Boolean, required: false }, // 是否使用上次选中时间
    pageDate: { type: Date, required: false, default: null },
    visible: { type: Boolean, required: true },
    isEditable: { type: Boolean, required: false, default: false },
    editApprovalDate: { type: Boolean, required: false },
    poNo: { type: String, required: false, default: '' }
  },
  data() {
    return {
      innerVisible: this.visible,
      accountDate: new Date(),
      pickerOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  computed: {
  },
  watch: {
    accountDate() {

    }
  },
  created() {
    if (this.showPageDate) {
      this.accountDate = moment(new Date(this.pageDate)).format('YYYY-MM-DD')
    }
  },
  methods: {
    disabledDate(currDate) {
      return currDate > new Date()
    },
    cancel() {
      this.$emit('update:visible', false)
      this.$emit('returnDatePage', this.accountDate)
    },
    close() {
      this.$emit('returnDatePage', this.accountDate)
    },
    async confirm() {
      await Assert.isNotBlank(this.accountDate, this.$t('CargoMsg.Cargo_PleaseSelectReviewDate'), 'warning')
      this.$emit('confirm', { accountDate: this.accountDate, poNo: this.poNo })
    }
  }
}
</script>

<style lang="scss">
</style>
